import { Injectable, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Modal } from './modal/modal';
import { AlertModal } from './alert/alert';
import { FatalModal } from './fatal/fatal';
import { Util } from "@common/utils/util";
import { ErrorModal } from './error/error';

declare var serverConfig: { [id: string]: any };

export type AutoFocusType = 'YesButton' | 'NoButton';

export class ModalResponseCodes {
    public static readonly OK = "Ok";
    public static readonly CANCEL = "Cancel";
    public static readonly RESTART = "Restart";
}

@Injectable({ providedIn: 'root' })
export class ModalService {

    public showWarningErrors: boolean = false;

    constructor(public dialog: MatDialog) {
        if (serverConfig["ShowWarnings"] && serverConfig["ShowWarnings"].toLowerCase) {
            this.showWarningErrors = (serverConfig["ShowWarnings"].toLowerCase() == "true");
        } else {
            this.showWarningErrors = false;
        }
    }

    public openModal(title: string | ElementRef, content: string | ElementRef | ElementRef, yesString: string | ElementRef | ElementRef, noString: string | ElementRef | ElementRef, autofocus?: AutoFocusType): any {
        autofocus = autofocus ? autofocus : 'YesButton';
        const autoFocus: string = (autofocus == 'NoButton') ? '.st-modal-button-no' : '.st-modal-button-yes';
        const dialogRef = this.dialog.open(Modal, {
            data: {
                title: title,
                content: content,
                yes: yesString,
                no: noString
            },
            hasBackdrop: true,
            delayFocusTrap: true,
            autoFocus: autoFocus
        });
        return {
            'result': dialogRef.afterClosed().toPromise()
        }
    }

    public openServiceErrorModal(modalInfo: { title?: string, message: string, detailedMessage?: string }): any {
        if (!this.showWarningErrors) return;
        if (!modalInfo.title) {
            modalInfo.title = "Warning";
        }
        const dialogRef = this.dialog.open(ErrorModal, {
            data: {
                title: modalInfo.title,
                message: modalInfo.message,
                detailed: modalInfo.detailedMessage
            },
            hasBackdrop: true,
            delayFocusTrap: true,
            autoFocus: '.st-modal-button-continue'
        });
        Util.saveWarningError(modalInfo.detailedMessage || modalInfo.message);
        return {
            'result': dialogRef.afterClosed().toPromise()
        }
    }

    public openServiceFatalErrorModal(modalInfo: { title?: string, message: string, detailedMessage: string }, runtime: boolean = false): any {
        if (!modalInfo.title) {
            modalInfo.title = "Error";
        }
        const dialogRef = this.dialog.open(FatalModal, {
            data: {
                title: modalInfo.title,
                message: modalInfo.message,
                detailed: modalInfo.detailedMessage
            },
            hasBackdrop: true,
            delayFocusTrap: true,
            autoFocus: '.st-modal-button-reset'
        });
        Util.saveCriticalError(modalInfo.detailedMessage, runtime);
        return {
            'result': dialogRef.afterClosed().toPromise()
        }
    }

    public openAlert(title?: string | ElementRef, content?: string, okString?: string) {
        okString = okString || 'OK';
        const dialogRef = this.dialog.open(AlertModal, {
            data: {
                title: title,
                content: content,
                ok: okString
            },
            hasBackdrop: true,
            delayFocusTrap: true,
            autoFocus: '.st-modal-button-ok'
        });
        return {
            'result': dialogRef.afterClosed().toPromise()
        }
    }

    public beforeDissmis() {
        return false;
    }
}
